import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  static targets = ["hidden", "visible", "formField"]
  connect() {
    this.synchronize()
  }

  wrapLogicalSyntax(text) {
    const wrapLogic = (text) => `<span class="text-blue-400">${text}</span>`;
    const wrapVariable = (variable) => `<span class="text-emerald-400">${variable}</span>`;

    // Helper function for balanced bracket parsing
    function parseBalancedExpressions(text) {

      // Process ALEA syntax
      let processed = text.replace(/ALEA\{(.*?)\}/g, (match, content) => {
        const wrappedContent = content.replace(/\|/g, wrapLogic('|'));
        return wrapLogic('ALEA{') + wrappedContent + wrapLogic('}');
      });

      let result = '';
      let i = 0;

      while (i < processed.length) {
        // Check if we have a logical expression
        if (processed.substring(i).startsWith('?{(')) {
          let conditionStart = i + 3; // Skip past "?{("
          let parenLevel = 1;
          let conditionEnd = conditionStart;

          // Find the end of the condition
          while (parenLevel > 0 && conditionEnd < processed.length) {
            if (processed[conditionEnd] === '(') parenLevel++;
            if (processed[conditionEnd] === ')') parenLevel--;
            conditionEnd++;
          }

          if (parenLevel !== 0) {
            // Unmatched parentheses, just include the text as is
            result += processed.substring(i);
            break;
          }

          // Extract and process the condition
          const condition = processed.substring(conditionStart, conditionEnd - 1);

          // Find the matching closing brace for the entire expression
          let braceStart = conditionEnd;
          let braceLevel = 1;
          let expressionEnd = braceStart;

          while (braceLevel > 0 && expressionEnd < processed.length) {
            // Check for nested expressions
            if (processed.substring(expressionEnd).startsWith('?{(')) {
              braceLevel++;
              expressionEnd += 3; // Skip past "?{("
            } else if (processed[expressionEnd] === '{') {
              braceLevel++;
              expressionEnd++;
            } else if (processed[expressionEnd] === '}') {
              braceLevel--;
              expressionEnd++;
            } else {
              expressionEnd++;
            }
          }

          if (braceLevel !== 0) {
            // Unmatched braces, include as is
            result += processed.substring(i);
            break;
          }

          // Process the inner content (excluding the closing brace)
          const body = processed.substring(braceStart, expressionEnd - 1);
          const processedBody = parseBalancedExpressions(body);

          // Add the wrapped expression to the result
          result += wrapLogic('?{(' + condition + ')') + processedBody + wrapLogic('}');

          // Move the index past this expression
          i = expressionEnd;
        } else {
          // Regular text, add it to the result
          result += processed[i];
          i++;
        }

        // Process variables first

      }

      result = result.replace(/\$(\b[A-Z_]+\b)/g, (match, varName) => {
        return wrapVariable(`$${varName}`);
      });


      return result;
    }


    return parseBalancedExpressions(text);
  }

  synchronize() {
    console.log("Sync")
    this.visibleTarget.innerHTML = this.wrapLogicalSyntax(this.hiddenTarget.innerHTML);
  };

  decodeHTML() {
    console.log("Correct")
    let content = this.hiddenTarget.innerHTML
      .replace(/<div>/g, '\n')
      .replace(/<br>/g, '\n')
      .replace(/<[^>]*>?/gm, '')
      .replace('\n\n\n', '\n\n');
    var tempElement = document.createElement('textarea');
    tempElement.innerHTML = content;
    this.formFieldTarget.value = tempElement.value;
  }

  scrollMirror() {
    this.visibleTarget.scrollTo(this.hiddenTarget.scrollLeft, this.hiddenTarget.scrollTop);
  };

  handleKey(ev) {
    if (ev.key === "Enter" && !ev.shiftKey) {
      // prevent Enter key behavior (new-line)
      ev.preventDefault();

      // Check message to send...
      const message = this.hiddenTarget.innerHTML;
      if (!message.trim()) {
        return; // Nothing to submit. Message is empty
      }

      // YOUR SUBMIT LOGIC GOES HERE:
      console.log(message);

      // Clear fields:
      this.hiddenTarget.innerHTML = "";
      this.visibleTarget.innerHTML = "";
    } else {
      // Any other key: (scroll areas is necessary)
      scrollMirror(this.hiddenTarget, this.visibleTarget);
    }
  };
}
